import { Navigate, Route } from 'react-router';
import SubNavigationLayout from '../../common/components/SubNavigationLayout';
import ErrorBoundary from '../../common/error/ErrorBoundary';
import SubMenu from '../navigation/SubMenu';
import CreatePinboardMessage from '../pinboardMessages/CreatePinboardMessage';
import EditPinboardMessage from '../pinboardMessages/EditPinboardMessage';
import PinboardMessages from '../pinboardMessages/PinboardMessages';
import ViewPinboardMessage from '../pinboardMessages/ViewPinboardMessage';
import UserAdverts from '../userAdverts/UserAdverts';

/**
 * Adverts feature routes (Anslagstavlan)
 * Base path: adverts/
 *
 * Routes:
 * - information - List all pinboard messages
 * - information/create - Create new pinboard message
 * - information/:id - View pinboard message
 * - information/:id/edit - Edit pinboard message
 * - user-adverts - List user adverts
 */
export const advertRoutes = (
    <Route
        element={
            <SubNavigationLayout
                subNavigation={
                    <ErrorBoundary key="/submenu/adverts">
                        <SubMenu parentId="adverts" />
                    </ErrorBoundary>
                }
            />
        }
    >
        <Route index element={<Navigate to="user-adverts" replace />} />
        <Route path="information">
            <Route
                index
                element={
                    <ErrorBoundary key="adverts/information">
                        <PinboardMessages />
                    </ErrorBoundary>
                }
            />
            <Route
                path="create"
                element={
                    <ErrorBoundary key="adverts/information/create">
                        <CreatePinboardMessage />
                    </ErrorBoundary>
                }
            />
            <Route path=":id">
                <Route
                    index
                    element={
                        <ErrorBoundary key="adverts/information/:id">
                            <ViewPinboardMessage />
                        </ErrorBoundary>
                    }
                />
                <Route
                    path="edit"
                    element={
                        <ErrorBoundary key="adverts/information/:id/edit">
                            <EditPinboardMessage />
                        </ErrorBoundary>
                    }
                />
            </Route>
        </Route>
        <Route
            path="user-adverts"
            element={
                <ErrorBoundary key="adverts/user-adverts">
                    <UserAdverts />
                </ErrorBoundary>
            }
        />
    </Route>
);
